import SeoHead from "../components/SeoHead";
import Signup from "../components/Signup/Signup";

export default function signup() {
  return (
    <>
      <SeoHead pageName="Signup" />
      <Signup />
    </>
  );
}
